import { useContext } from 'react';

import TutorialContext from './TutorialContext';

// explainAction(id, handler) wraps a control's handler so the control's
// explanation shows before its first use. Outside the help provider the handler
// runs untouched.
const useExplainAction = () => {
  const context = useContext(TutorialContext);
  return context?.tutorial.explainAction ?? ((id, handler) => handler);
};

export default useExplainAction;
